<template>
    <div
        @mouseenter="openHeaders"
        @mouseleave="closeHeaders"
        class="header-hover-util"
        :class="{
            'debug-mode': debugMode,
            'sectors-sidebar-open': isSectorsSidebarOpen && isShowingSubSidebarHeaders,
            'floorplans-sidebar-open': isFloorplansSidebarOpen && isShowingSubSidebarHeaders,
        }"
    >
        <div @click="$emit('showMapSidebar')" v-if="isShowingSubSidebarHeaders" class="show-map-sidebar"></div>
        <div @click="$emit('showSectorsSidebar')" v-if="isShowingSubSidebarHeaders" class="show-sectors-sidebar"></div>
    </div>
</template>

<script>
export default {
    props: {
        /**
         * determines if SectorsSidebar is open
         */
        isSectorsSidebarOpen: {
            type: Boolean,
            default: false,
        },
        /**
         * determines if FloorplansSidebar is open
         */
        isFloorplansSidebarOpen: {
            type: Boolean,
            default: false,
        },
        /**
         * determines if subsidebar headers are showing or not (when mouse is hovering)
         */
        isShowingSubSidebarHeaders: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            debugMode: false,
        }
    },
    methods: {
        openHeaders() {
            this.$emit('openHeaders')
        },
        closeHeaders() {
            this.$emit('closeHeaders')
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/scss/components/360Viewer/Sidebar/Floorplans/header-hover-util.scss';
</style>
